import { useSiteConfig } from "@/context/SiteConfigContext";

export function telHref(num) {
  return `tel:${(num || "").replace(/\s/g, "")}`;
}

export function waHref(num, text) {
  const clean = (num || "").replace(/[^0-9]/g, "");
  const msg = encodeURIComponent(text || "Hello, I would like to enquire about the JUPEB / IJMB programmes at the School of Basic Studies, IAUE.");
  return `https://wa.me/${clean}?text=${msg}`;
}

// Returns the apply target: external URL if configured, else a marker to open the enquiry modal.
export function useApplyTarget() {
  const { config } = useSiteConfig();
  const url = (config.applicationUrl || "").trim();
  return { url, hasExternal: !!url };
}
